let dept = {
  saveOrgDeptNet: {
    //新增部门信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/saveOrgDept',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      deptName: '',
      //	T	部门名称
      parentId: '',
      //	T	上级部门ID，一级部门（单位） = 0
      deptType: '',
      //	T	部门类别：1：单位（支持多级单位）； 2：部门
      areaCode: '',
      //	F	行政区域码，获取通过查询行政区域列表接口 如果deptType=1，则必填
      shortName: '',
      //	F	部门简称
      corpTel: '',
      //	F	部门
      corpAddr: '',
      //	F	部门地址
      sortIndex: '' //	F	部门排序， 默认0

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //新增部门id

    }
  },
  updateOrgDeptNet: {
    //更新部门信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/updateOrgDept',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '',
      //部门id
      deptName: '',
      //	T	部门名称
      parentId: '',
      //	T	上级部门ID，一级部门（单位） = 0
      deptType: '',
      //	T	部门类别：1：单位（支持多级单位）； 2：部门
      areaCode: '',
      //	F	行政区域码，获取通过查询行政区域列表接口 如果deptType=1，则必填
      shortName: '',
      //	F	部门简称
      corpTel: '',
      //	F	部门
      corpAddr: '',
      //	F	部门地址
      sortIndex: '' //	F	部门排序， 默认0

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //结果内容

    }
  },
  deleteOrgDeptNet: {
    //删除部门信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/deleteOrgDept',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      ids: '' //id 多个以“，”分隔

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //结果内容

    }
  },
  getOrgDeptDetailNet: {
    //查询部门详情信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/getOrgDeptDetail',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '' //部门编号

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        //	T	
        parentId: '',
        //	T	上级部门ID
        deptName: '',
        //	T	部门名称
        firstLetter: '',
        //	T	部门名称拼音首字母
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //	T	排序
        pathName: '',
        //	T	部门全称
        syncKey: '',
        //	T	同步KEY,该字段在和其他系统对接时使用
        deptDesc: '',
        //	T	描述
        deptExt: '',
        //	T	扩展字段, 建议使用json格式
        isActive: '',
        //	T	是否激活: 0-否; 1-是
        modifyTime: '',
        //	T	记录修改时间
        createTime: '',
        //	T	记录创建时间
        parentDeptName: '',
        //	T	父部门名称
        deptType: '' //	T	部门类型: 1-公司; 2-部门

      }
    }
  },
  queryOrgDeptNet: {
    //分页查询部门列表信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/queryOrgDept',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      parentId: '',
      //	F	上级部门ID
      deptName: '',
      //	F	部门名称
      firstLetter: '',
      //	F	首字母
      orgCode: '',
      //	F	组织编码
      currentPage: '',
      //	F	当前页码
      pageSize: '',
      //	F	每页条数
      modifyTimeStart: '',
      //	F	记录修改开始时间
      modifyTimeEnd: '' //	F	记录修改结束时间

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        pageNum: '',
        //	当前页
        pageSize: '',
        //	每页的数量
        size: '',
        //	当前页的数量
        startRow: '',
        //	当前页面第一个元素在数据库中的行号
        endRow: '',
        //	当前页面最后一个元素在数据库中的行号
        total: '',
        //总记录数
        pages: '',
        //总页数
        list: [{
          id: '',
          //	T	
          parentId: '',
          //	T	上级部门ID
          deptName: '',
          //	T	部门名称
          firstLetter: '',
          //	T	部门名称拼音首字母
          orgCode: '',
          //	T	组织编码
          sortIndex: '',
          //	T	排序
          pathName: '',
          //	T	部门全称
          syncKey: '',
          //	T	同步KEY,该字段在和其他系统对接时使用
          deptDesc: '',
          //	T	描述
          deptExt: '',
          //	T	扩展字段, 建议使用json格式
          isActive: '',
          //	T	是否激活: 0-否; 1-是
          modifyTime: '',
          //	T	记录修改时间
          createTime: '',
          //	T	记录创建时间
          parentDeptName: '',
          //	T	父部门名称
          corpTel: '',
          //	公司联系方式
          corpAddr: '',
          //	公司地址
          shortName: '',
          //	公司层的部门简称
          deptType: '' //	T	部门类型: 1-公司; 2-部门

        }],
        //	结果集
        modifyPwTime: '',
        //密码修改时间
        firstPage: '',
        //	第一页
        perPage: '',
        //	前一页
        nextPage: '',
        //	下一页
        lastPage: '',
        //	最后一页
        isFirstPage: '',
        //	是否为第一页
        isLastPage: '',
        //	是否为最后一页
        hasPreviousPage: '',
        //	是否有前一页
        hasNextPage: '',
        //	是否有下一页
        navigatePage: '',
        //	导航页码数
        navigatePageNums: '' //	所有导航页号

      }
    }
  },
  listOrgDeptNet: {
    //查询部门列表信息
    url: '/scooper-core-rest/data/contacts/orgDeptManage/listOrgDept',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      parentId: '',
      //	F	上级部门ID
      orgCode: '',
      //	F	组织编码
      deptType: '',
      //	F	部门类型，默认为2  1、一级部门（单位）  2、二级及以下部门 3、所有部门全查
      modifyTimeStart: '',
      //	F	记录修改开始时间
      modifyTimeEnd: '' //	F	记录修改结束时间

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	
        parentId: '',
        //	T	上级部门ID
        deptName: '',
        //	T	部门名称
        firstLetter: '',
        //	T	部门名称拼音首字母
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //	T	排序
        pathName: '',
        //	T	部门全称
        syncKey: '',
        //	T	同步KEY,该字段在和其他系统对接时使用
        deptDesc: '',
        //	T	描述
        deptExt: '',
        //	T	扩展字段, 建议使用json格式
        isActive: '',
        //	T	是否激活: 0-否; 1-是
        modifyTime: '',
        //	T	记录修改时间
        createTime: '',
        //	T	记录创建时间
        parentDeptName: '',
        //	T	父部门名称
        corpId: '',
        //	T	公司联系方式
        deptType: '' //	T	部门类型: 1-公司; 2-部门

      }]
    }
  },
  listDeptByParentNet: {
    //按层级加载部门(树型结构)
    url: '/scooper-core-rest/data/contacts/orgDeptManage/listDeptByParent',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      orgCorpId: '',
      //	F	公司编号
      id: '',
      //	F	上级部门编号ID             (默认为0)
      firstExpand: '',
      //	F	是否为第一次加载           true/fasle
      expandMember: '' //	F	是否加载其下部门成员信息   true/fasle

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	节点ID
        name: '',
        //	T	节点名称
        childNum: '',
        //	T	子节点数量
        dataType: '',
        //	T	数据类型
        data: '',
        //	自定义数据
        isParent: '',
        //	是否为父节点
        pid: '' //	T	父节点ID

      }]
    }
  },
  findDepartmentPathNet: {
    //查询某部门在树形结构中的路径
    url: '/scooper-core-rest/data/contacts/orgDeptManage/findDepartmentPath',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '' //	T	部门编号ID 

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	
        parentId: '',
        //	T	上级部门ID
        deptName: '',
        //	T	部门名称
        firstLetter: '',
        //	T	部门名称拼音首字母
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //	T	排序
        pathName: '',
        //	T	部门全称
        syncKey: '',
        //	T	同步KEY,该字段在和其他系统对接时使用
        deptDesc: '',
        //	T	描述
        deptExt: '',
        //	T	扩展字段, 建议使用json格式
        isActive: '',
        //	T	是否激活: 0-否; 1-是
        modifyTime: '',
        //	T	记录修改时间
        createTime: '',
        //	T	记录创建时间
        parentDeptName: '',
        //	T	父部门名称
        corpId: '',
        //	T	公司联系方式
        deptType: '' //	T	部门类型: 1-公司; 2-部门

      }]
    }
  },
  listTreeDeptByParentNet: {
    //层级加载部门树结构

    /**
     * 从一部部门（单位）开始加载，即id=0开始加载可加载完整的通讯录数据（部门&成员）
     */
    url: '/scooper-core-rest/data/contacts/orgDeptManage/listTreeDeptByParent',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '',
      //	T	部门编号ID 
      orgCorpId: '',
      //	F	单位id
      firstExpand: '',
      //	F	是否为第一次加载           true/fasle
      expandMember: '' //	F	是否加载其下部门成员信息   true/fasle

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	T	节点ID
        name: '',
        //	T	节点名称
        childNum: '',
        //	T	子节点数量
        dataType: '',
        //	T	数据类型 orgMember: 部门成员 orgDept: 部门
        data: '',
        //	T	自定义数据
        isParent: '',
        //	T	是否为父节点
        pid: '' //	T	父节点ID

      }]
    }
  },
  findDeptMemberCountNet: {
    //查询某部门下成员数量
    url: '/scooper-core-rest/data/contacts/orgDeptManage/findDeptMemberCount',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '',
      //	T	部门编号ID 
      type: '' //两种模式：0：本层下所有成员数 （默认） 1：包含下级部门的所有成员数

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //数量

    }
  },
  changeDeptSortIndexNet: {
    //修改部门排序
    url: '/scooper-core-rest/data/contacts/orgDeptManage/changeDeptSortIndex',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '',
      //	T	部门编号ID 
      sortIndex: '',
      //新排序号
      oldSortIndex: '' //旧排序号

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {} //结果内容

    }
  },
  listDeptMemberByDeotIdNet: {
    //查询某部门下成员列表
    url: '/scooper-core-rest/data/contacts/orgDeptManage/listDeptMemberByDeotId',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      id: '' //	T	部门编号ID 

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        //部门成员数组
        id: '',
        //	T	
        deptId: '',
        //	T	部门ID
        memCode: '',
        //	T	成员编号
        memName: '',
        //	T	成员姓名
        sex: '',
        //	T	性别，1：男；2：女
        firstLetter: '',
        //	T	姓名拼音首字母
        memTel: '',
        //	T	成员号码
        memType: '',
        //	T	成员类型:0-一般用户；1-视频话机用户；2-移动终端用户；
        memMobile: '',
        //	T	手机号码
        memTel2: '',
        //	T	号码二
        memTel3: '',
        //	T	号码三
        memTel4: '',
        //	T	号码四
        memTel5: '',
        //	T	号码五
        memFax: '',
        //	T	传真号码
        memEmail: '',
        //	T	电子邮箱
        memPicture: '',
        //	T	图片
        memVideo: '',
        //	T	视频
        memGis: '',
        //	T	GI坐标
        orgCode: '',
        //	T	组织编码
        sortIndex: '',
        //	T	排序号
        updateTime: '',
        //	T	更新时间
        deptExt: '',
        //	T	扩展字段
        isActive: '',
        //	T	是否激活
        modifyTime: '',
        //	T	记录修改时间
        memLevel: '',
        //	T	成员等级
        memQq: '',
        //	T	QQ号码
        deptName: '' //	T	部门名称

      }]
    }
  },
  listAdCodeNet: {
    //查询行政区域列表信息
    url: '/scooper-core-rest/data/contacts/orgCorpManage/listAdCode',
    method: 'POST',
    requestParam: {
      token: '',
      //	T	身份令牌
      areaCodeParent: '' //	F	上级行政区划代码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        //行政区域列表
        id: '',
        //	T	
        areaCode: '',
        //	T	行政区域代码
        areaName: '',
        //	T	行政区域名称
        areaCodeParent: '',
        //	T	上级行政区划代码
        areaLevel: '' //	T	地区级别：1-省；2-市；3-区县；4-镇

      }]
    }
  },

  /**
   * MQTT订阅
   */
  orgDeptAddMQNet: function () {
    //新增部门信息通知
    return {
      topic: '/scooper_core/dataChange/orgDept',
      responseParam: {
        id: '',
        type: 'add',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  orgDeptUpdateMQNet: function () {
    //更新部门信息通知
    return {
      topic: '/scooper_core/dataChange/orgDept',
      responseParam: {
        id: '',
        type: 'update',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  orgDeptDeleteMQNet: function () {
    //删除部门信息通知
    return {
      topic: '/scooper_core/dataChange/orgDept',
      responseParam: {
        id: '',
        type: 'delete',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: '' //删除的id, 多个以“,”分隔

      }
    };
  },

  /**
   * HTTP推送
   */
  orgDeptAddHttpNet: function () {
    return {
      //新增部门信息通知HTTP推送通知
      url: '/data/dataChange/orgDept/add',
      method: 'POST',
      requestParam: {
        id: '' //新增部门ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  orgDeptUpdateHttpNet: function () {
    return {
      //更新部门信息通知HTTP推送通知
      url: '/dataChange/orgDept/update',
      method: 'POST',
      requestParam: {
        id: '' //更新部门ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  orgDeptDeleteHttpNet: function () {
    return {
      //删除部门信息通知HTTP推送通知
      url: '/dataChange/orgDept/delete',
      method: 'POST',
      requestParam: {
        id: '' //id 多个以“，”分隔

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  }
  /*** end  */

};
export default dept;